module.exports = __webpack_public_path__ + "static/media/black_and_decker.cda3b711.png";